import { useTranslation } from "react-i18next";

import { DataProps } from "../types";
import StatsTag from "./StatsTag";

const SupportStats = ({ data }: DataProps) => {
    const { t } = useTranslation();

    const { companyInfo } = data;

    const getTitle = (firstPart: string, secondPart?: string | number | null) =>
        `${firstPart}: ${secondPart || "—"}`;

    return (
        <div data-testid="transfer-companies-support-stats">
            <StatsTag title={getTitle(t(`Table##code`), companyInfo?.lzCode)} />

            <StatsTag
                title={getTitle(
                    t(`General##vip status`),
                    companyInfo?.vipStatus
                )}
            />

            <StatsTag
                title={getTitle(
                    t(`General##company type`),
                    companyInfo?.companyType
                )}
            />

            <StatsTag
                title={getTitle(
                    t(`General##company level`),
                    companyInfo?.companyLevel
                )}
            />
        </div>
    );
};

export default SupportStats;
